import React from 'react';
const BONUSES = [{
  id: 1,
  title: 'Checklist Anti-Pelea',
  description: 'Lo mínimo para que la tarea no termine mal. Una guía paso a paso para preparar el terreno antes de empezar.',
  image: 'https://cdn.magicpatterns.com/uploads/4zAaRQ3eiAg1WG8Qio9tpx/98dfb991-49c1-4480-957c-d4479cab13c1.png'
}, {
  id: 2,
  title: 'Banco de Frases que Destraban',
  description: 'Qué decir exactamente cuando no entiende (sin explicar de más). Palabras mágicas para desbloquear la mente.',
  image: 'https://cdn.magicpatterns.com/uploads/8BypGknhAZibhaHRpDfQay/ChatGPT_Image_15_ene_2026,_11_16_18_p.m..png'
}, {
  id: 3,
  title: 'Guía de Emergencia',
  description: 'Qué hacer cuando la tarea ya empezó mal. Protocolo de rescate para momentos de crisis y llanto.',
  image: 'https://cdn.magicpatterns.com/uploads/sJkpetVg1EgMeaQxiM7pdW/ChatGPT_Image_15_ene_2026,_11_20_52_p.m..png'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 bg-amber-50/50 rounded-3xl my-12 border border-amber-100" data-id="element-1">
      <div className="text-center mb-10 px-4" data-id="element-2">
        <span className="inline-block px-4 py-1 bg-red-100 text-red-600 font-bold rounded-full text-sm mb-4 tracking-wide uppercase" data-id="element-3">
          Regalos Exclusivos
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-4">
          Llevate estos 3 Bonos <span className="text-amber-600" data-id="element-5">GRATIS</span>{' '}
          hoy
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-6">
          Herramientas prácticas diseñadas para situaciones específicas. El
          complemento perfecto para el método principal.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 px-4 max-w-6xl mx-auto" data-id="element-7">
        {BONUSES.map(bonus => <div key={bonus.id} onClick={scrollToPurchase} className="group cursor-pointer bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100" data-id="element-8">
            <div className="relative aspect-[3/4] overflow-hidden bg-gray-100" data-id="element-9">
              <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" data-id="element-10" />
              <div className="absolute top-4 right-4 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-11">
                VALOR: $15 USD
              </div>
              <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm py-2 px-4 rounded-lg text-center shadow-sm" data-id="element-12">
                <span className="text-green-600 font-bold text-sm" data-id="element-13">
                  HOY GRATIS
                </span>
              </div>
            </div>
            <div className="p-6" data-id="element-14">
              <h3 className="font-bold text-xl text-gray-900 mb-2 group-hover:text-amber-600 transition-colors" data-id="element-15">
                {bonus.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-16">
                {bonus.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}